import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';
import { LoadingScreen } from '@/components/common/loading-spinner';

export function LogoutPage() {
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      // signOut hard-navigates so the next login can't inherit this session's
      // module instances / API caches. Handing it the destination keeps that
      // to a single cycle — a plain reload would land back on /logout and
      // only reach /login on the second pass.
      await signOut({ redirectTo: '/login' });
      // Only reached when there was no session to sign out (signOut skips the
      // navigation in that case), so a client-side route change is enough.
      navigate('/login', { replace: true });
    };
    doLogout();
  }, [signOut, navigate]);

  return <LoadingScreen message="Signing out..." />;
}
